import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchPeopleResponse } from './search-people-response';
import { searchPeopleResponseSchema } from './search-people-response';

export async function searchPeopleApi(
  query: string,
): Promise<IValidatedResponse<ISearchPeopleResponse>> {
  return getRequest<ISearchPeopleResponse>({
    path: '/people/v1/search',
    schema: searchPeopleResponseSchema,
    options: { params: { query } },
  });
}
